import { Backdrop, CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import MvmApi from '../../../services/MvmApi';
import nfe from './images/nfe.png';
import truck from './images/truck.png';
import { useStyles } from './Style';

type props =  any;

interface iSummaryData {
    title: string;
    items: iSummaryItem[];
}

interface iSummaryItem {
    title: string;
    mvms: string;
    invoices: string;
}

const MvmMonitorSumary: React.FC<props> = ({ plantId }) => {
    const classes = useStyles();
    const [lista, setLista] = useState<iSummaryData[]>([]);
    const [openBackdrop, setOpenBackdrop] = React.useState(true);
    const { t } = useTranslation("MvmMonitor");

    const { isLoading, isFetching, data, refetch } = useQuery('monitorMvmSummary_'+plantId, async () => {
        return await MvmApi.getMonitorSumary(plantId);
    } ,{
        refetchOnWindowFocus: false,
        staleTime: 1000 * 30, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 30, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    useEffect(() => {
        if (data)
            setLista(data);

    }, [data])

    useEffect(() => {
        setOpenBackdrop(isFetching);
    }, [isFetching])

    useEffect(() => {refetch();}, [plantId]);

    return (
        <div style={{display: 'flex', flexDirection: 'column', padding: 4}}>

                <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <table style={{width: '100%'}} cellSpacing={0} cellPadding={0}>
                    <tr>
                        <td >
                        <Typography style={{textAlign: 'center', fontSize: 26, fontWeight: 'bold', padding: 10, color: '#597DDA'}}>
                            {plantId === 1 && t('title_FIAT')}
                            {plantId === 2 && t('title_CAMPOLARGO')}
                            {plantId === 3 && t('title_JEEP')}
                        </Typography>
                        </td>
                        <td style={{width: 120, textAlign: 'center'}}>
                            <img src={truck} alt='truck' width={30} height={30}/>
                        </td>
                        <td style={{width: 120, textAlign: 'center'}}>
                            <img src={nfe} alt='nfe' width={30} height={30}/>
                        </td>
                    </tr>
                </table>
                <table className={classes.table} cellSpacing={0} cellPadding={0}>
                    { lista.map((reg: iSummaryData) => (
                        <tr key={reg.title}>
                            <td className={classes.td}>
                                {t('title_' + reg.title)}
                            </td>
                            <td >
                                <table className={classes.subtable} cellSpacing={0} cellPadding={0}>
                                    {reg.items.map((item: iSummaryItem) => (
                                        <tr key={item.title}>
                                            <td className={classes.td}>
                                                {t('title_' + item.title)}
                                            </td>
                                            <td className={classes.qtd} colSpan={item.invoices === '' ? 2 : 1}>
                                                {item.mvms}
                                            </td>
                                            {item.invoices !== '' && (
                                            <td className={classes.qtd}>
                                                {item.invoices}
                                            </td>
                                            )}
                                        </tr>
                                    ))}
                                </table>
                            </td>
                        </tr>
                    ))}
                </table>
                <br />
                <br />
                {t('lastUpdate')}: {new Date().toLocaleString()}

        </div>
    )
}
export default MvmMonitorSumary;
